import { render, staticRenderFns } from "./ArchiveDialog.vue?vue&type=template&id=79f03299&"
import script from "./ArchiveDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports